angular.module 'zc.commonApi'

# Textual search for projects
# if string is present in apikey or title
.filter 'projectText', () ->
  return (projects, filterText) ->

    result = _.filter projects, (project) ->
      return true unless filterText

      conditions = [
        project.title
        project.apikey
        project.base_url
        project.id
      ]

      # check if every keyword meets all condition
      keywords = filterText.split /\s/
      _.every keywords, (keyword) ->

        # check if keyword meets ANY condition
        _.some conditions, (condition) ->
          condition = condition + '' if typeof condition isnt 'string'
          return true if condition && condition.indexOf(keyword) > -1
          false

    result



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/filters/project_text_filter.js.coffee